import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'status',
  standalone: true
})
export class StatusPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    const statusMap: Record<string, { label: string; class: string }> = {
      OPEN: { label: 'Open', class: 'open' },
      PROCESSING: { label: 'Verwerken', class: 'processing' },
      PROCESSED: { label: 'Verwerkt', class: 'processed' },
      BILLED: { label: 'Gefactureerd', class: 'billed' },
      COMPLETED: { label: 'Afgerond', class: 'completed' },
      CANCELLED: { label: 'Geannuleerd', class: 'cancelled' },
      SENT_TO_PRINTER: { label: 'Naar printer', class: 'processing' },
      IN_PRODUCTION: { label: 'In productie', class: 'processing' },
      SENT: { label: 'Verzonden', class: 'processed' },
    };

    const status = statusMap[String(value)];
    if (!status) return null;

    return `<span class="badge badge-${status.class}">${status.label}</span>`;
  }
}
